import { css } from 'emotion';

import { fadeIn } from '../styles/helpers';

export const fadeInClassName = css`
  opacity: 0;
  animation: ${fadeIn} 0.27s forwards;
`;

export const pulseClassName = css`
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-duration: 1s;
`;
